<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="icon-user icons d-block mr-3"></i>
      {{userName}}
      <i class="icon-arrow-down icons d-block ml-3 mr-3"></i>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Uitloggen</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapActions } from 'vuex';

export default {
  name: 'DefaultHeaderDropdownAccent',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  computed: {
      userName () {
          return this.$store.state.userName
      }
  },
  methods: {
    ...mapActions([
      'logout'
    ])
  }
}
</script>
